import React, { useState } from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import ItemPlace from './ItemPlace/ItemPlace';
import './GamePage.css';

const GamePage = (props) => {
    const [AnswerValue, setAnswerValue] = useState('?');
    const [AnswerClassName, setAnswerClassName] = useState('Answer');
    const [AskHidden, setAskHidden] = useState(false);
    const [isStarsHidden, setIsStarsHidden] = useState(false);
   
    const handleAnswer = ((pri) => {
        if (pri === 'answer') {
            setAnswerValue(props.gameWords[0].words);
            setAnswerClassName('Answer newColor');
            setAskHidden(true);
            setIsStarsHidden(true);
            setTimeout(() => {
                setIsStarsHidden(false);
                setTimeout(props.onClick, 2000, 'answer');
            }, 2000);
        }

    });

    const askWord = props.gameWords.map((items) =>
        <ItemPlace key={items.place} className={'Place' + items.place} itemContent={items} onClick={(pri) => handleAnswer(pri)} />
       );
       
       return (
        <div>
            <img src={props.bgSrc} className='bgGame' alt=' ' />
            <img src={props.src} className='gameImg' alt=' ' />
               <div hidden={AskHidden} > {askWord} </div>
               <div hidden={!isStarsHidden} >
                   <div className='Stars Star1'> </div> <div className='Stars Star2'> </div>
                   <div className='Stars Star3'> </div> <div className='Stars Star4'> </div>
               </div>
            <Text className='GameQuestion' value={props.textGame.GameQuestion[props.lang]} />
            <Text className='GameInfo' value={props.textGame.GameInfo[props.lang]} />
            <div className={AnswerClassName}>{AnswerValue}</div>
               <Button className='GamePrev' onClick={() => props.onClick('prev')} hidden={((props.step === 0) || AskHidden ) ? true : false} /> 
        </div>
    );
    };

export default GamePage;